<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="博主名称">
          <el-input placeholder="请输入博主名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加博主</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
         
            <el-table-column prop="user.nickName" label="申请人"></el-table-column>
                <el-table-column prop="name" label="申请达人"></el-table-column>

            <el-table-column prop="business_license" label="相关材料">
                <template slot-scope="scope">
   
                  <div v-if="scope.row.coverimgs">
                    <el-image
                    v-for="(item,index) in scope.row.coverimgs" :key="index"
                    :src="item.file_path" width="50px" height="50px"
                    :preview-src-list="[item.file_path]"
                    style="width: 50px;height: 50px;"
                    ></el-image>
                  </div>
                </template>
          </el-table-column>

            <el-table-column prop="user.mobile" label="联系电话"></el-table-column>
            <el-table-column prop="audit_status" label="审核状态" width="150">
              <template slot-scope="scope">

                <div v-if="scope.row.audit_status == 0">未审核</div>
                <div v-if="scope.row.audit_status == 1">审核通过</div>
                <div v-if="scope.row.audit_status == 2">审核不通过</div>
              </template>

            </el-table-column>
            <el-table-column prop="reject_val" label="不通过原因" width="150"></el-table-column>


            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>

            <!-- <el-table-column label="账期操作" width="90">
              <template slot-scope="scope">
    
                <a @click="zqClick(scope.row)">操作</a>
              </template>
            </el-table-column>   -->

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-if="scope.row.audit_status == 0" @click="passClick(scope.row)" 
              
                type="text" size="small">通过</el-button><br />
                <el-button v-if="scope.row.audit_status == 0" 
                   
                @click="nopassClick(scope.row)" type="text" size="small">不通过</el-button><br />
    
                <!-- <el-button @click="jumpClick(scope.row)" type="text" size="small">下单记录</el-button> -->
                <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :compay_id="compay_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import CompayApi from '@/api/compay.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        compay_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      zqClick(row){//账期操作
        this.$router.push({
        path: '/order/order/index',
        query: {
          compay_id: row.compay_id
        }
      });
      },
      jumpClick(row){
        this.$router.push({
        path: '/order/order/index',
        query: {
          compay_id: row.compay_id
        }
      });
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//博主标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        CompayApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.compay_id = row.compay_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            CompayApi.del(
              {
                compay_id: row.compay_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      async passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        compay_id:item.compay_id,
        audit_status:1,
        reject_val:""
      }
      CompayApi.pass(Params, true)
                          .then(data => {
                            if(data.code == 1){
                              self.$message({
                                  type: 'success',
                                  message: '审核成功'
                              });
                                self.getTableList();
                                return false;
                            }
                          })
                          .catch(error => {});
      

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原因', '请输入不通过的原因');

      var Params = {
        compay_id:item.compay_id,
        audit_status:2,
        reject_val:reject_val
      }
      console.log(reject_val)
      if(reject_val == undefined){
        console.log("取消")
      }else{
          if(reject_val.length > 0){
            CompayApi.nopass(Params, true)
                      .then(data => {
                        if(data.code == 1){
                          self.$message({
                              type: 'success',
                              message: '审核成功'
                          });
                            self.getTableList();
                            return false;
                        }
                      })
                      .catch(error => {});
          }else{
            this.$message({
              type: 'error',
              message: '请输入不通过的原因',
            });
          }
  
      }
     
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/compay/index/index.vue